(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/init.js');
'use strict';

var _svs, _svs$my_profile_react;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  MyProfileApp,
  UnsubscribePage
} = svs.myProfile;
const loadUnsubscribe = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.my_profile_react) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.loadUnsubscribe) || false;
svs.myProfile.init = () => {
  ReactDOM.render(loadUnsubscribe ? React.createElement(UnsubscribePage, null) : React.createElement(MyProfileApp, null), document.getElementsByClassName('js-player-profile-react-container')[0]);
};
svs.myProfile.init();
if ((_svs$my_profile_react = svs.my_profile_react.data) !== null && _svs$my_profile_react !== void 0 && _svs$my_profile_react.dialogData) {
  const dialogData = svs.my_profile_react.data.dialogData;
  const defaultData = {
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Något gick fel',
    actions: [{
      title: 'Okej'
    }]
  };
  if (dialogData.redirectLink) {
    dialogData.actions = [{
      title: 'Okej',
      showLoader: true,
      callback: () => {
        svs.utils.url.navigate(dialogData.redirectLink);
      }
    }];
  }
  if (dialogData.message) {
    dialogData.message = [{
      type: svs.ui.dialog.message.TEXT,
      text: dialogData.message
    }];
  }
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm(_objectSpread(_objectSpread({}, defaultData), dialogData)));
}

 })(window);